import { render, staticRenderFns } from "./EV3ImportUploader.vue?vue&type=template&id=4650d6d3&scoped=true"
import script from "./EV3ImportUploader.vue?vue&type=script&lang=js"
export * from "./EV3ImportUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4650d6d3",
  null
  
)

export default component.exports